import React, { useState, useEffect } from 'react';
import { subscribeToPush, unsubscribeFromPush, getSubscriptionStatus } from '../pushSubscription';

function PushNotificationToggle() {
  const [status, setStatus] = useState({ supported: false, subscribed: false, permission: 'default' });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    getSubscriptionStatus()
      .then(setStatus)
      .catch(() => setStatus({ supported: false, subscribed: false, permission: 'default' }))
      .finally(() => setLoading(false));
  }, []);

  const showMessage = (text) => {
    setMessage(text);
    setTimeout(() => setMessage(''), 3000);
  };

  const handleToggle = async () => {
    setLoading(true);
    try {
      if (status.subscribed) {
        await unsubscribeFromPush();
        setStatus((prev) => ({ ...prev, subscribed: false }));
        showMessage('Push-Benachrichtigungen deaktiviert');
      } else {
        await subscribeToPush();
        setStatus((prev) => ({ ...prev, subscribed: true, permission: 'granted' }));
        showMessage('Push-Benachrichtigungen aktiviert');
      }
    } catch (err) {
      showMessage(err.message || 'Fehler bei Push-Benachrichtigungen');
    } finally {
      setLoading(false);
    }
  };

  if (!status.supported) return null;

  const denied = status.permission === 'denied';

  return (
    <div className="relative">
      <button
        onClick={handleToggle}
        disabled={loading || denied}
        className={`flex-1 sm:flex-none font-medium py-2 sm:py-3 px-3 sm:px-4 rounded-lg transition-all duration-200 flex items-center justify-center space-x-1 sm:space-x-2 ${
          denied
            ? 'bg-red-900/50 text-red-400 cursor-not-allowed'
            : status.subscribed
            ? 'bg-emerald-700 hover:bg-emerald-600 text-white'
            : 'bg-zinc-600 hover:bg-zinc-500 text-zinc-100'
        }`}
        title={
          denied
            ? 'Push-Berechtigung blockiert - bitte in Browser-Einstellungen erlauben'
            : status.subscribed
            ? 'Push-Benachrichtigungen deaktivieren'
            : 'Push-Benachrichtigungen aktivieren'
        }
      >
        {denied ? (
          <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3l18 18" />
          </svg>
        ) : status.subscribed ? (
          <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C10.9 2 10 2.9 10 4c0 .1 0 .2.02.3C7.12 5.14 5 7.82 5 11v5l-2 2v1h18v-1l-2-2v-5c0-3.18-2.12-5.86-5.02-6.7.02-.1.02-.2.02-.3 0-1.1-.9-2-2-2zm0 20c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z" />
          </svg>
        ) : (
          <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
        )}
        {loading && (
          <svg className="w-3 h-3 sm:w-4 sm:h-4 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        )}
      </button>
      {message && (
        <div className="absolute top-full mt-2 right-0 z-50 bg-zinc-700 border border-zinc-600 text-zinc-100 text-xs sm:text-sm px-3 py-2 rounded-lg shadow-lg whitespace-nowrap">
          {message}
        </div>
      )}
    </div>
  );
}

export default PushNotificationToggle;
